export enum ModalType {
  OPEN_POSITION = "OPEN_POSITION",
  OPEN_FIXED_POSITION = "OPEN_FIXED_POSITION",
  CLOSE_POSITION = "CLOSE_POSITION",
  EZ_VAULT = "EZ_VAULT",
  EZ_VAULT_MIGRATION = "EZ_VAULT_MIGRATION",
  LOCK_WITHDRAW = "LOCK_WITHDRAW",
  AIRDROP = "AIRDROP",
  SOCIAL_SHARE = "SOCIAL_SHARE",
}
